import { Components, Theme } from '@mui/material/styles';

const tabsTheme: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      ' [aria-label="standard"]': {
        minHeight: "30px",
        marginTop: theme.spacing(1),
        background: theme.palette.warmBlue,
      },
    }),
    indicator: {
      display: "none",
    },
  },
};

export default tabsTheme;
